import { useMutation } from "@tanstack/react-query"

import { apiContextFetch } from "@/hooks/api/base"
import { useApiContext } from "@/hooks/api/use-api-context"

interface CredentialCheckVars {
  crmUsername: string
  crmPassword: string
}

// Validates the Redtail login by fetching the user roster; resolves on success,
// throws (so the caller can block) on a bad login or unreachable users.
export function useRedtailCredentialCheck() {
  const getContext = useApiContext()

  return useMutation<void, Error, CredentialCheckVars>({
    mutationFn: async ({ crmUsername, crmPassword }) => {
      const ctx = await getContext()
      if (!ctx) throw new Error("No context found")
      await apiContextFetch<void>(ctx, "redtail/credential_checks", {
        method: "POST",
        body: JSON.stringify({
          credential_check: { crm_username: crmUsername, crm_password: crmPassword },
        }),
      })
    },
  })
}
